import React from 'react'
import { useSearchFormTemplatesQuery } from '@/core/services/form'
import { SearchFormTemplateDto, FormTemplate } from '@/core/models/form.model'
import FormTemplateSearch from '../components/FormTemplateSearch'

interface FormTemplateSearchContainerProps {
    value: SearchFormTemplateDto
    onChange: (value: SearchFormTemplateDto) => void
}

const FormTemplateSearchContainer: React.FC<FormTemplateSearchContainerProps> = ({
    value,
    onChange,
}) => {
    // Get all templates to extract unique categories and tags
    const { data: templates } = useSearchFormTemplatesQuery({
        search: { isActive: true },
        skip: 0,
        limit: 100, // Get a reasonable number of templates to extract categories and tags
        orderBy: 'createdAt',
        order: 'DESC'
    })

    // Extract unique categories and tags from all templates
    const availableCategories = React.useMemo(() => {
        if (!templates?.items) return []
        const categories = new Set<string>()
        templates.items.forEach((template: FormTemplate) => {
            if (template.categories) {
                template.categories.forEach((category: string) => categories.add(category))
            }
        })
        return Array.from(categories).sort()
    }, [templates])

    const availableTags = React.useMemo(() => {
        if (!templates?.items) return []
        const tags = new Set<string>()
        templates.items.forEach((template: FormTemplate) => {
            if (template.tags) {
                template.tags.forEach((tag: string) => tags.add(tag))
            }
        })
        return Array.from(tags).sort()
    }, [templates])

    return (
        <FormTemplateSearch
            value={value}
            onChange={onChange}
            availableCategories={availableCategories}
            availableTags={availableTags}
        />
    )
}

export default FormTemplateSearchContainer 